import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentPageGridComponent } from './content-page-grid.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { pageOccConfig } from './core/content-page-grid.occ';

@NgModule({
  declarations: [ContentPageGridComponent],
  imports: [CommonModule, RouterModule],
  providers: [
    provideConfig(pageOccConfig),
    provideConfig({
      cmsComponents: {
        ContentPageGrid: {
          component: ContentPageGridComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class ContentPageGridModule {}
